export const getErrorMessageFromPrismicContent = (code, content) =>
    content[code][0]?.text ?? 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut';
